import Vue from 'vue'
import firebase from '@/firebase/firebase'

const db = firebase.firestore()

export default {
    namespaced : true,

    state : {
        taxesToBeSend : {}
    },

    actions : {
        setTaxByPerson ({ commit, state }, tax) {
            if(!state.taxesToBeSend.byPerson)
                commit('addTaxByPerson', tax)
            else
                commit('editTaxByPerson', tax)
        },

        deleteTaxByPerson ({commit}) {
            commit('removeTaxByPerson')
        }
    },

    mutations : {
        cleanUp(state) {
            state.taxesToBeSend = []
        },

        addTaxByPerson (state, tax) {
            Vue.set(state.taxesToBeSend, 'byPerson', tax)
        },

        editTaxByPerson (state, tax) {
            const persons = state.taxesToBeSend.byPerson.persons + tax.persons
            const editedTax = { 
                ...tax,
                totalByPersonPaid : persons * tax.value,
                persons : persons  
            } 
            Vue.set(state.taxesToBeSend, 'byPerson', editedTax)
        },

        removeTaxByPerson (state) {
            Vue.set(state.taxesToBeSend, 'byPerson')
        },
        
        changeByPersonQuantity(state, val) {
            const editedTax = {
                ...state.taxesToBeSend.byPerson,
                totalByPersonPaid : val * state.taxesToBeSend.byPerson.value,
                persons : val
            }

            Vue.set(state.taxesToBeSend, 'byPerson', editedTax)
        }
    }
}